const LoadingPage = () => (
  <section className="loading-screen">
    <span className="loader"/>
  </section>
);

export default LoadingPage;